// ===================================
// SIDEBAR COMPONENT - FIXED
// src/components/layout/Sidebar.js
// Stage 11 Fix: Added admin switch for admin users
// ===================================

import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
    onClose?.();
  };

  // Navigation items
  const navItems = [
    { path: '/app/dashboard', icon: '🏠', label: 'Dashboard' },
    { path: '/app/book', icon: '📅', label: 'Book Session' },
    { path: '/app/sessions', icon: '📋', label: 'My Sessions' },
      { path: '/app/start-session', icon: '🔑', label: 'Validate Code' },  // <-- NEW

    { path: '/app/progress', icon: '📊', label: 'Progress' },
    { path: '/app/achievements', icon: '🏆', label: 'Achievements' },
    { path: '/app/settings', icon: '⚙️', label: 'Settings' }
  ];

  return (
    <>
      {/* Mobile overlay */}
      <div 
        className={`sidebar-overlay ${isOpen ? 'active' : ''}`}
        onClick={onClose}
      />

      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        {/* Logo */}
        <div className="sidebar-logo">
          <NavLink to="/app/dashboard" onClick={onClose}>
            <span className="logo-icon">🎯</span>
            <span className="logo-text2">Career-Coach<span>.AI</span></span>
          </NavLink>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {navItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* Admin Switch - Only shown for admin users */}
        {user?.is_admin && (
          <div className="admin-switch-section">
            <NavLink 
              to="/admin/dashboard" 
              className="admin-switch-btn"
              onClick={onClose}
            >
              <span className="admin-switch-icon">⚙️</span>
              <span className="admin-switch-text">
                <span className="admin-switch-label">Admin Panel</span>
                <span className="admin-switch-desc">Manage platform</span>
              </span>
              <span className="admin-switch-arrow">→</span>
            </NavLink>
          </div>
        )}

        {/* User Section */}
        <div className="sidebar-user">
          {user && (
            <div className="user-info">
              <div className="user-avatar">
                {user.name?.charAt(0) || user.username?.charAt(0) || '?'}
              </div>
              <div className="user-details">
                <span className="user-name">{user.name || user.username}</span>
                <span className="user-role">
                  {user.is_admin ? '👑 Administrator' : 'Member'}
                </span>
              </div>
            </div>
          )}
          
          <div className="sidebar-actions">
            <NavLink 
              to="/app/settings" 
              className="sidebar-action-btn"
              title="Settings"
              onClick={onClose}
            >
              ⚙️
            </NavLink>
            <button 
              className="sidebar-action-btn logout"
              onClick={handleLogout}
              title="Logout"
            >
              🚪
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;